import { ArticleCard } from '@pickleballinc/features';
import { useSession } from '@pickleballinc/ui/components/global/SessionProvider';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import clsx from 'clsx';
import { useState } from 'react';

import { FavoriteButton } from '@/modules/blog/article_components/FavoriteButton';
import { RenderFavoritedNewsModule } from '@/types/homepage.types';

interface FavoriteArticleCardProps {
  isPlayerProfilePage?: boolean;
  favoriteArticle: RenderFavoritedNewsModule;
  shouldHideFavoriteButton?: boolean;
  onRefetch?: () => void;
}

export const FavoriteArticleCard = ({
  isPlayerProfilePage,
  favoriteArticle,
  shouldHideFavoriteButton,
  onRefetch,
}: FavoriteArticleCardProps) => {
  const [isFavorited, setIsFavorited] = useState(true);
  const { session } = useSession();

  return (
    <div
      key={favoriteArticle.moduleUuid}
      className={clsx('relative w-full max-w-[480px] bg-white cursor-pointer rounded-lg', {
        'bg-white shadow-md': isPlayerProfilePage,
      })}
    >
      <CustomLink
        href={`/${favoriteArticle.newsCategorySlug}/${favoriteArticle.slug}`}
        className='flex items-start justify-center'
      >
        <ArticleCard
          imageUrl={favoriteArticle.imageUrl}
          title={favoriteArticle.title}
          alt={favoriteArticle.imageAltText}
          description={favoriteArticle.description}
          type='favorited'
        />
      </CustomLink>
      {session?.user?.uuid && !shouldHideFavoriteButton ? (
        <div className='absolute right-4 top-4 sm:right-6 sm:top-6 z-10'>
          <FavoriteButton
            moduleUuid={favoriteArticle.moduleUuid}
            isFavorited={isFavorited}
            setIsFavorited={setIsFavorited}
            variant='icon'
            onSuccessToggle={onRefetch}
          />
        </div>
      ) : null}
    </div>
  );
};
